<template>
  <div class="flex flex-wrap mb-2" :style="(guideStep >= 19 && guideStep <= 34) || (guideStep == 271 || guideStep == 272) ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div :ref="stageTreeList?.list?.Objective.refName" v-show="stageContenttData?.goalsData.showBlock"  style="position:relative">
        <loading :active="!showObjectiveLoading"
                :can-cancel="true"
                :on-cancel="onCancel"
                :is-full-page="false"
                :color="'#fff'"
                :background-color="'#000'"
                :opacity="'0.8'"
                :loader=" dots">
        </loading>
        <div class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">目標</span>
          <span class="text-xs text-gray-400 pl-4">受眾符合的條件</span>
        </div>
        <div class="grid grid-cols-2">
          <div class="mx-4" style="border-right: 1px dashed #9ca3af;">
            <div class="space-y-2" style="position:relative">
              <loading :active="!this.showGoalsAndBudget || !showGoalsAndBudgetMyside"
                      :can-cancel="true"
                      :on-cancel="onCancel"
                      :is-full-page="false"
                      :color="'#fff'"
                      :background-color="'#000'"
                      :opacity="'0.8'"
                      :loader=" dots">
              </loading>
              <!-- 新手教學 -->
              <div
                class="grid grid-cols-2"
                :class="{ 'ring-4 border-blue-400': guideStep === 20 }"
              >
                <!-- 新手教學 -->
                <div class="inline-flex items-center" :class="{ 'ring-4 border-blue-400': guideStep === 21 }">
                  <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="CONVERSIONS" :disabled="editPageType" v-model="campaignObjective" @click="objective_change($event)"/>
                  <div class="flex flex-col w-11/12 break-words" >
                    <div class="flex ml-2 text-gray-700 my-2">
                      <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['conversions_title']}}</span>
                    </div>
                  </div>
                </div>
                <div class="inline-flex items-center">
                  <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="VIDEO_VIEWS" :disabled="editPageType || (useASC == true && stageContenttData?.method == 'META_TEST') || stageContenttData?.method == 'META_ASC'" v-model="campaignObjective" @click="objective_change($event)">
                  <!-- <span class="ml-2 text-gray-700">觀看影片</span> -->
                  <!-- 新手教學 -->
                  <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 25 }">
                    <div class="flex ml-2 text-gray-700 my-2">
                      <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['video_views_title']}}</span>
                    </div>
                  </div>
                </div>
                <div class="inline-flex items-center">
                  <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="LINK_CLICKS" :disabled="editPageType || (useASC == true && stageContenttData?.method == 'META_TEST') || stageContenttData?.method == 'META_ASC'" v-model="campaignObjective" @click="objective_change($event)">
                  <!-- <span class="ml-2 text-gray-700">流量</span> -->
                  <!-- 新手教學 -->
                  <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 23 }">
                    <div class="flex ml-2 text-gray-700 my-2">
                      <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['link_clicks_title']}}</span>
                    </div>
                  </div>
                </div>
                <div class="inline-flex items-center">
                  <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="LEAD_GENERATION" :disabled="editPageType || (useASC == true && stageContenttData?.method == 'META_TEST') || stageContenttData?.method == 'META_ASC'" v-model="campaignObjective" @click="objective_change($event)">
                  <!-- <span class="ml-2 text-gray-700">開發潛在顧客</span> -->
                  <!-- 新手教學 -->
                  <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 26 }">
                    <div class="flex ml-2 text-gray-700 my-2">
                      <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['lead_generation_title']}}</span>
                    </div>
                  </div>
                </div>
                <div class="inline-flex items-center">
                  <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="POST_ENGAGEMENT" :disabled="editPageType || (useASC == true && stageContenttData?.method == 'META_TEST') || stageContenttData?.method == 'META_ASC'" v-model="campaignObjective" @click="objective_change($event)">
                  <!-- <span class="ml-2 text-gray-700">互動</span> -->
                  <!-- 新手教學 -->
                  <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 24 }">
                    <div class="flex ml-2 text-gray-700 my-2">
                      <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['post_engagement_title']}}</span>
                    </div>
                  </div>
                </div>
                <div class="inline-flex items-center">
                  <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="MESSAGES" :disabled="editPageType || (useASC == true && stageContenttData?.method == 'META_TEST') || stageContenttData?.method == 'META_ASC'" v-model="campaignObjective" @click="objective_change($event)">
                  <!-- <span class="ml-2 text-gray-700">發送訊息</span> -->
                  <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 27 }">
                    <div class="flex ml-2 text-gray-700 my-2">
                      <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['messages_title']}}</span>
                    </div>
                  </div>
                </div>
                <div class="inline-flex items-center">
                  <input
                    type="radio"
                    class="form-radio h-5 w-5 text-blue-600"
                    :disabled="editPageType || (useASC == true && stageContenttData?.method == 'META_TEST') || stageContenttData?.method == 'META_ASC'"
                     value="PRODUCT_CATALOG_SALES" v-model="campaignObjective" @click="objective_change($event)"
                  />
                  <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 271 }" >
                    <div class="flex ml-2 text-gray-700 my-2">
                      <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['product_catalog_sales_title']}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-4">
            <div class="mt-4">
              <div v-if="campaignObjective == 'CONVERSIONS'" class="items-center">
                <div class="flex flex-col w-full break-words" >
                  <div class="text-gray-700 mb-2">
                    <div class="flex justify-between mb-2">
                      <span class="text-sm" style="line-height:36px;">{{lang['components']['Event']['GoalsAndBudget']['conversions_title']}}</span>

                      <button
                        v-if="!editPageType"
                        class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
                        @click="objective_update(campaignObjective)">
                        <i class="pi pi-refresh"></i>
                        更新
                      </button>
                    </div>

                    <CascadeSelect
                      :disabled="editPageType"
                      v-model="stageContenttData.goalsData.objective_option"
                      :options="stageContenttData.goalsData.objective_list"
                      optionLabel="name"
                      optionValue="code"
                      optionGroupLabel="name"
                      :optionGroupChildren="['sub']"
                      style="minwidth: 14rem"
                      class="w-full rounded-md"
                      placeholder="-"
                      v-if="campaignObjective == 'CONVERSIONS'"
                    >
                    </CascadeSelect>
                  </div>
                  <!-- 新手教學 -->
                  <div class="text-gray-700 my-2">
                    <span class="text-sm">{{lang['components']['Event']['GoalsAndBudget']['conversion_domain_title']}}</span>
                    <Dropdown
                      :disabled="editPageType"
                      v-model="stageContenttData.goalsData.conversion_domain"
                      :options="stageContenttData.goalsData.domain_list"
                      :filter="true"
                      optionLabel="name"
                      placeholder="-"
                      class="w-full rounded-md"
                      v-if="campaignObjective == 'CONVERSIONS'"
                    >
                      <template #header>
                        <div class="flex px-4 pt-2">
                          <input
                            v-model="domain"
                            type="text"
                            autocomplete="off"
                            class="p-dropdown-filter p-inputtext p-component"
                          />
                          <div
                            v-on:click="setDomain"
                            class="flex-none px-3 py-2 ml-1 bg-blue rounded-md cursor-pointer"
                          >
                            <i class="pi pi-plus text-white"></i>
                          </div>
                        </div>
                      </template>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div v-if="campaignObjective == 'VIDEO_VIEWS'" class="items-center">
                <!-- 新手教學 -->
                <div class="flex-col w-full break-words">
                  <div class="text-gray-700">
                    <div class="flex justify-between mb-2">
                      <span class="text-sm" style="line-height:36px;">{{lang['components']['Event']['GoalsAndBudget']['video_views_title']}}</span>

                      <button
                        v-if="!editPageType"
                        class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
                        @click="objective_update(campaignObjective)">
                        <i class="pi pi-refresh"></i>
                        更新
                      </button>
                    </div>
                    <Dropdown :disabled="editPageType" v-model="stageContenttData.goalsData.objective_option" optionLabel="name" optionValue="code" :options="stageContenttData.goalsData.objective_list" placeholder="--" class="w-full rounded-md"/>
                  </div>
                </div>
              </div>
              <div v-if="campaignObjective == 'LINK_CLICKS'" class="items-center">
                <!-- 新手教學 -->
                <div class="flex-col w-full break-words">
                  <div class="text-gray-700">
                    <div class="flex justify-between mb-2">
                      <span class="text-sm" style="line-height:36px;">{{lang['components']['Event']['GoalsAndBudget']['link_clicks_title']}}</span>

                      <button
                        v-if="!editPageType"
                        class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
                        @click="objective_update(campaignObjective)">
                        <i class="pi pi-refresh"></i>
                        更新
                      </button>
                    </div>
                    <Dropdown :disabled="editPageType" v-model="stageContenttData.goalsData.objective_option" optionLabel="name" optionValue="code" :options="stageContenttData.goalsData.objective_list" placeholder="--" class="w-full rounded-md" />
                  </div>
                </div>
              </div>
              <div v-if="campaignObjective == 'LEAD_GENERATION'" class="items-center">
                <!-- 新手教學 -->
                <div class="flex-col w-full break-words">
                  <div class="text-gray-700">
                    <div class="flex justify-between mb-2">
                      <span class="text-sm" style="line-height:36px;">{{lang['components']['Event']['GoalsAndBudget']['lead_generation_title']}}</span>

                      <button
                        v-if="!editPageType"
                        class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
                        @click="objective_update(campaignObjective)">
                        <i class="pi pi-refresh"></i>
                        更新
                      </button>
                    </div>
                    <Dropdown :disabled="editPageType" v-model="stageContenttData.goalsData.objective_option" optionLabel="name" optionValue="code" :options="stageContenttData.goalsData.objective_list" placeholder="--" class="w-full rounded-md" />
                  </div>
                </div>
              </div>
              <div v-if="campaignObjective == 'POST_ENGAGEMENT'" class="items-center">
                <!-- 新手教學 -->
                <div class="flex-col w-full break-words">
                  <div class="text-gray-700">
                    <div class="flex justify-between mb-2">
                      <span class="text-sm" style="line-height:36px;">{{lang['components']['Event']['GoalsAndBudget']['post_engagement_title']}}</span>

                      <button
                        v-if="!editPageType"
                        class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
                        @click="objective_update(campaignObjective)">
                        <i class="pi pi-refresh"></i>
                        更新
                      </button>
                    </div>
                    <Dropdown :disabled="editPageType" v-model="stageContenttData.goalsData.objective_option" optionLabel="name" optionValue="code" :options="stageContenttData.goalsData.objective_list" placeholder="--" class="w-full rounded-md" />
                  </div>
                </div>
              </div>
              <div v-if="campaignObjective == 'MESSAGES'" class="items-center">
                <div class="flex-col w-full break-words">
                  <div class="text-gray-700">
                    <div class="flex justify-between mb-2">
                      <span class="text-sm" style="line-height:36px;">{{lang['components']['Event']['GoalsAndBudget']['messages_title']}}</span>

                      <button
                        v-if="!editPageType"
                        class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
                        @click="objective_update(campaignObjective)">
                        <i class="pi pi-refresh"></i>
                        更新
                      </button>
                    </div>
                    <Dropdown :disabled="editPageType" v-model="stageContenttData.goalsData.objective_option" optionLabel="name" optionValue="code" :options="stageContenttData.goalsData.objective_list" placeholder="--" class="w-full rounded-md" />
                  </div>
                </div>
              </div>
              <div v-if="campaignObjective == 'PRODUCT_CATALOG_SALES'" class="items-center">
                <div class="flex-col w-full break-words" >
                  <div class="text-gray-700">
                    <div class="flex justify-between mb-2">
                      <div>
                        <span class="text-sm" style="line-height:36px;">{{lang['components']['Event']['GoalsAndBudget']['product_catalog_sales_title']}}</span>
                        <i
                          class="mt-1 ml-2 pi pi-exclamation-circle align-middle text-gray-300"
                          v-tooltip="`${lang['components']['Event']['GoalsAndBudget']['product_catalog_sales_title_info']}`"
                        ></i>
                      </div>

                      <button
                        v-if="!editPageType"
                        class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
                        @click="objective_update(campaignObjective)">
                        <i class="pi pi-refresh"></i>
                        更新
                      </button>
                    </div>
                    <Dropdown :disabled="editPageType" v-model="stageContenttData.goalsData.product_catalog_id" optionLabel="name" optionValue="code" :options="stageContenttData.goalsData.product_catalog_list" placeholder="--" class="w-full rounded-md" @change="product_catalog_change($event)" />

                  </div>
                  <div class="text-gray-700">
                    <span class="text-sm">{{lang['components']['Event']['GoalsAndBudget']['product_catalog_id_title']}}</span>
                    <Dropdown :disabled="editPageType || (stageContenttData?.goalsData.product_catalog_id == '' || typeof stageContenttData?.goalsData.product_catalog_id == 'undefined')" v-model="stageContenttData.goalsData.product_set_id" optionLabel="name" optionValue="code" :options="stageContenttData.goalsData.product_set_list" placeholder="--" class="w-full rounded-md" @change="product_set_change($event)" />
                  </div>
                  <div class="text-gray-700">
                    <span class="text-sm">{{lang['components']['Event']['GoalsAndBudget']['product_set_id_title']}}</span>
                    <Dropdown :disabled="editPageType || (stageContenttData?.goalsData.product_set_id == '' || typeof stageContenttData?.goalsData.product_set_id == 'undefined')" v-model="stageContenttData.goalsData.objective_option" optionLabel="name" optionValue="code" :options="stageContenttData.goalsData.objective_list" placeholder="--" class="w-full rounded-md" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :ref="stageTreeList?.list?.Budget.refName" v-show="stageContenttData?.budgetData.showBlock">
        <div class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">預算</span>
        </div>
        <div class="grid grid-cols-2 gap-8">
          <div style="border-right: 1px dashed #9ca3af;">
            <div class="grid grid-cols-2 gap-8">
              <div class="space-y-2 pb-8">
                <div>
                  <span v-if="!editPageType" class="text-red-500">*</span>
                  <span class="text-grap-700 align-middle text-sm">預算</span>
                  <!-- <i
                    class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                    v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['effect_title_info']}`"
                  ></i> -->
                </div>
                <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-48">
                  <input
                    :disabled="editPageType || dynBudgetData.useDynamicBudget == true"
                    type="text"
                    class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                    v-model="stageContenttData.budgetData.daily_budget"
                    oninput="value=Number(value.replace(/[^\d]/g, ''))"
                    @blur="budgetLimit(stageContenttData?.budgetData.daily_budget, stageContenttData?.method, stageContenttData?.budgetData.budget_limit)"
                  />
                  <span class="text-xs text-gray-400">{{currencyListData.currency}}</span>
                </div>
                <div>
                <span v-if="!editPageType" class="text-red-500">*</span>
                <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['GoalsAndBudget']['effect_title']}}</span>
                <i
                  class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                  v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['effect_title_info']}`"
                ></i>
                <button
                  v-if="!editPageType"
                  id="effect"
                  class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
                  @click="teachVideo('effect')"
                >
                  {{lang['components']['Event']['GoalsAndBudget']['video_teaching']}}
                  </button>
                </div>
                <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-48">
                  <input
                    :disabled="editPageType"
                    type="text"
                    class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                    v-model="stageContenttData.budgetData.effect"
                    @keyup="num(stageContenttData?.budgetData.effect, currencyListData.currency_offset, 'effect', '', '')"
                  />
                  <span class="text-xs text-gray-400">{{currencyListData.currency}}</span>
                </div>
              </div>
              <div v-if="stageContenttData?.method == 'META_ASC'" class="space-y-2 pb-8">
                <div>
                  <div>
                    <span class="text-grap-700 align-middle text-sm">現有顧客預算比例</span>
                    <i
                      class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                      v-tooltip.top="'若要設定現有顧客預算比例，你必須先在廣告帳號設定現有顧客。'"
                    ></i>
                  </div>
                  <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-48 mt-2">
                    <input
                      :disabled="editPageType"
                      type="number"
                      min="0"
                      max="100"
                      class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                      v-model="stageContenttData.budgetData.existing_customer_budget_percentage"
                      oninput = "value=value.replace(/[^\d]/g,'')"
                      @input="validateInput"
                    />
                    <span class="text-xs text-gray-400">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 29 || guideStep === 30 || guideStep === 31 || guideStep === 32 || guideStep === 33 }">
              <div>
                <!-- <span class="text-red-500">*</span> -->
                <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['GoalsAndBudget']['risk_level_title']}}</span>
                <i
                  v-if="false"
                  class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                  v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['risk_level_title_info']}`"
                ></i>
                <button
                  v-if="!editPageType"
                  id="risk_level"
                  class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
                  @click="teachVideo('risk')"
                >
                  {{lang['components']['Event']['GoalsAndBudget']['video_teaching']}}
                </button>
              </div>

              <SelectButton
                :disabled="editPageType"
                v-model="stageContenttData.budgetData.risk_level"
                :options="stageContenttData.budgetData.risk_level_list"
                optionLabel="name"
              >
                <template #option="slotProps">
                  <div class="w-48" :class="{ 'h-26': useLang == 'en-US', 'h-16': (useLang == 'zh-CN' || useLang == 'zh-TW') }">
                    <!-- <p :class="{ 'hor-ver-center': budgetUse != slotProps.option }">
                      {{ slotProps.option.name }}
                    </p>
                    <p v-if="budgetUse == slotProps.option" class="text-xs">
                      {{ slotProps.option.sub }}
                    </p> -->
                    <p :class="{ 'hor-ver-center': stageContenttData.budgetData.risk_level.code != slotProps.option.code }">
                      {{ slotProps.option.name }}
                    </p>
                    <p v-if="stageContenttData.budgetData.risk_level.code == slotProps.option.code" class="text-xs">
                      {{ stageContenttData.budgetData.risk_level.sub }}
                    </p>
                  </div>
                </template>
              </SelectButton>
            </div>
            <!-- <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 34 }">
              <div class="flex">
                <div>
                  <span class="text-red-500">*</span>
                  <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['GoalsAndBudget']['form_addition_title']}}</span>
                  <i
                    class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                    v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['form_addition_title_info']}`"
                  ></i>
                  <button
                    v-if="!editPageType"
                    id="addition"
                    class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
                    @click="teachVideo('addition')"
                  >
                    {{lang['components']['Event']['GoalsAndBudget']['video_teaching']}}
                  </button>
                </div>
                <div class="text-grap-700 text-sm ml-4 mt-1">
                  <InputSwitch v-model="stageContenttData.goalsData.use_addition" class="-my-1" />
                  <span class="mx-1">{{lang['components']['Event']['GoalsAndBudget']['use_addition_title']}}</span>
                </div>
              </div>

              <div class="flex flex-wrap">
                <span class="text-sm text-gray-500 mr-2 mt-1">{{lang['components']['Event']['GoalsAndBudget']['add_text']}}</span>
                <div
                  class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-24"
                >
                  <input
                    type="text"
                    class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                    v-model="stageContenttData.goalsData.form_addition"
                    oninput = "value=value.replace(/[^\d]/g,'')"
                    :disabled="!stageContenttData.goalsData.use_addition"
                  />
                  <span class="text-xs text-gray-400">%</span>
                </div>
                <span v-if="false" class="bg-white text-blue-500 text-sm ml-2 mt-1">最低 {{minAddition}} %</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div :ref="stageTreeList?.list?.Freq.refName">
        <div class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">規則頻率（前進/暫停）</span>
        </div>
        <div>
          <div class="grid grid-cols-12 pb-3">
            <div class="col-span-5">
              <div class="border border-gray-200 p-1">
                <div class="grid grid-cols-3" style="height:42px;">
                  <div class="pl-2" style="line-height: 42px;">判斷頻率</div>
                  <div class="col-span-2 text-right pr-2">
                    每
                    <Dropdown v-model="stageContenttData.forwardData.frequency" optionLabel="name" optionValue="code" :options="timeType" placeholder="請選擇條件" class="w-3/8" style="height: 42px;"/>
                    判斷一次
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :ref="stageTreeList?.list?.Forward.refName" v-show="stageContenttData.forwardData.showBlock && (stageIndex + 1) != stageContentLength">
        <div class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">前進規則</span>
          <span class="text-xs text-gray-400 pl-4">進入下一階段的規則</span>
          <div v-show="stageIndex != 0" class="float-right">
            <span class="text-sm mr-2">套用前階段設定</span>
            <InputSwitch v-model="stageContenttData.forwardData.ditto_forward" class="-my-1" />
          </div>
        </div>
        <div class="mt-6">
          <RuleForwardGroup v-model:filters="stageContenttData.forwardData.rule_frequency" :conditionCount="ruleFrequencyConditionCount" :canAddCondition="canAddCondition" @changeData="changeDataFilters"/>
        </div>
      </div>
      <div :ref="stageTreeList?.list?.Stop.refName" v-show="stageContenttData.stopData.showBlock">
        <div class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">暫停條件</span>
          <span class="text-xs text-gray-400 pl-4">停止進行的條件</span>
          <div v-show="stageIndex != 0" class="float-right">
            <span class="text-sm mr-2">套用前階段設定</span>
            <InputSwitch v-model="stageContenttData.stopData.ditto_stop" class="-my-1" />
          </div>
        </div>
        <div class="mt-6">
          <RuleStopGroup v-model:filters="stageContenttData.stopData.rule_stop" :conditionCount="ruleStopConditionCount" :canAddCondition="canStopAddCondition" @changeStopData="changeStopDataFilters"/>
        </div>
      </div>
      <div :ref="stageTreeList?.list?.FreqRaise.refName" v-show="stageContenttData.budgetExtraData.showBlock">
        <div class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">規則頻率（加碼）</span>
        </div>
        <div>
          <div class="grid grid-cols-12 pb-3">
            <div class="col-span-5">
              <div class="border border-gray-200 p-1">
                <div class="grid grid-cols-3" style="height:42px;">
                  <div class="pl-2" style="line-height: 42px;">判斷頻率</div>
                  <div class="col-span-2 text-right pr-2">
                    每
                    <Dropdown v-model="stageContenttData.budgetExtraData.frequency_raise" optionLabel="name" optionValue="code" :options="timeType" placeholder="請選擇條件" class="w-3/8" style="height: 42px;"/>
                    判斷一次
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :ref="stageTreeList?.list?.Raise.refName" v-show="stageContenttData.budgetExtraData.showBlock">
        <div class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">預算加碼</span>
          <div v-show="stageIndex != 0" class="float-right">
            <span class="text-sm mr-2">套用前階段設定</span>
            <InputSwitch v-if="stageContenttData?.budgetExtraData" v-model="stageContenttData.budgetExtraData.ditto_budget_extra" class="-my-1" />
          </div>
        </div>

        <!-- <div class="grid grid-cols-3 gap-2 border-b border-dashed pb-2">
          <div class="px-2">
            <div>
              <span class="text-grap-700 align-middle text-sm">金額</span>
            </div>
            <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-full h-10">
              <input
                type="text"
                class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                v-model="stageContenttData.budgetExtraData.amount"
                oninput = "value=value.replace(/[^\d]/g,'')"
              />
              <span class="text-xs text-gray-400">{{currencyListData.currency}}</span>
            </div>
          </div>
          <div class="px-2">
            <div>
              <span class="text-grap-700 align-middle text-sm">次數</span>
            </div>
            <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-full h-10">
              <input
                type="text"
                min="0"
                max="10"
                step="1"
                class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                v-model="stageContenttData.budgetExtraData.frequency"
                oninput = "value=value.replace(/[^\d]/g,'')"
                @input="validateInput"
              />
              <span class="text-xs text-gray-400">次</span>
            </div>
          </div>
        </div>
        <div>
          <div v-for="(item, index) in stageContenttData.budgetExtraData.budget_extra_list" :key="index">
            <div class="grid grid-cols-12 py-2">
              <div class="col-span-2">
                <Dropdown v-if="index == 1" v-model="item.logicType" optionLabel="name" optionValue="code" :options="logicType" placeholder="請選擇條件" @change="changeStopLogicType(item.logicType)" class="w-full" :disabled="editPageType"/>
                <span v-else-if="index > 1" class="pl-2" style="line-height:42px;">{{item.logicType}}</span>
              </div>
              <div class="col-span-2">
                <Dropdown v-model="item.indexType" optionLabel="name" optionValue="code" :options="indexType" placeholder="請選擇條件" class="w-full" disabled="true" @change="indexTypeChange('stop', item.indexType, index)" :disabled="editPageType"/>
              </div>
              <div v-if="false" class="col-span-2">
                <Dropdown v-model="item.indexTypeSub" optionLabel="name" optionValue="code" :options="indexTypeSub" placeholder="請選擇條件" class="w-full" :disabled="item.subDisabled || editPageType"/>
              </div>
              <div class="col-span-2">
                <Dropdown v-model="item.compareType" optionLabel="name" optionValue="code" :options="compareType" placeholder="請選擇條件" class="w-full" :disabled="editPageType"/>
              </div>
              <div class="col-span-5">
                <div class="bg-white items-center p-1 shadow-sm border border-gray-200 w-full" style="height:42px;">
                  <input
                    type="text"
                    class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                    style="line-height:32px;"
                    v-model="item.num"
                    placeholder="輸入數值"
                    @keyup="num(item.num, currencyListData.currency_offset, 'budget_extra_list', item.indexType, index)"
                  />
                </div>
              </div>
              <div v-if="false" class="border border-gray-200">
                <div class="p-2 cursor-pointer" @click="clearBudgetExtraItems(index)">
                  <img class="w-6 h-6 cursor-pointer" style="margin: 0 auto;" src="../../assets/clear.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="false" class="grid grid-cols-12">
          <div class="col-span-2"></div>
          <div class="col-span-2">
            <div class="cursor-pointer" @click="addStopItems">
              <span class="pi pi-plus px-2"></span>新增規則
            </div>
          </div>
          <div class="col-span-8"></div>
        </div> -->
        


        <div class="mt-2">
          <button class="bg-blue-500 hover:bg-blue-800 text-white px-3 py-2 rounded-md" @click="addRuleRaiseItems">
            <span class="pi pi-plus pr-2"></span>新增加碼
          </button>
        </div>
        <div v-for="(item, index) in stageContenttData.budgetExtraData.budget_extra_list" :key="index" class="border rounded-md mt-2">
          <div class="grid grid-cols-3 gap-2 border-b border-dashed pb-2">
            <div class="px-2">
              <div>
                <span class="text-grap-700 align-middle text-sm">金額</span>
              </div>
              <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-full h-10">
                <input
                  type="text"
                  class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                  v-model="item.amount"
                  oninput = "value=value.replace(/[^\d]/g,'')"
                />
                <span class="text-xs text-gray-400">{{currencyListData.currency}}</span>
              </div>
            </div>
            <div class="px-2">
              <div>
                <span class="text-grap-700 align-middle text-sm">次數</span>
              </div>
              <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-full h-10">
                <input
                  type="text"
                  min="0"
                  max="10"
                  step="1"
                  class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                  v-model="item.times"
                  oninput = "value=value.replace(/[^\d]/g,'')"
                  @input="timesCheck(index)"
                />
                <span class="text-xs text-gray-400">次</span>
              </div>
            </div>
            <div class="px-2 text-right pt-2">
              <button
                v-if="ruleRaiseList.length > 1"
                @click="removeRuleRaiseList(index)"
                class="px-4 py-2 rounded text-white font-medium focus:outline-none transition bg-red-500 hover:bg-red-600 text-xs"
              >
                删除
              </button>
            </div>
          </div>
          <div>
            <div v-for="(filtersItem, filtersIndex) in item.filters" :key="filtersIndex">
              <div class="grid grid-cols-12 p-2">
                <div v-if="false" class="col-span-2">
                  <Dropdown v-if="filtersIndex == 1" v-model="filtersItem.logicType" optionLabel="name" optionValue="code" :options="logicType" placeholder="請選擇條件" @change="changeStopLogicType(filtersItem.logicType)" class="w-full" :disabled="editPageType"/>
                  <span v-else-if="filtersIndex > 1" class="pl-2" style="line-height:42px;">{{filtersItem.logicType}}</span>
                </div>
                <div class="col-span-2">
                  <Dropdown v-model="filtersItem.field" optionLabel="name" optionValue="code" :options="field" placeholder="請選擇條件" class="w-full"/>
                </div>
                <div class="col-span-2">
                  <Dropdown v-model="filtersItem.operator" optionLabel="name" optionValue="code" :options="compareType" placeholder="請選擇條件" class="w-full"/>
                </div>
                <div class="col-span-5">
                  <div class="bg-white items-center p-1 shadow-sm border border-gray-200 w-full" style="height:42px;">
                    <input
                      type="text"
                      class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                      style="line-height:32px;"
                      v-model="filtersItem.value"
                      placeholder="輸入數值"
                      @keyup="num(filtersItem.value, currencyListData.currency_offset, 'budget_extra_list', filtersItem.field, index)"
                    />
                  </div>
                </div>
                <div v-if="false" class="border border-gray-200">
                  <div class="p-2 cursor-pointer" @click="clearBudgetExtraItems(filtersIndex)">
                    <img class="w-6 h-6 cursor-pointer" style="margin: 0 auto;" src="../../assets/clear.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-1/4 rounded-xl space-y-2 px-4 mt-12" style="width:425px;" :style="stageContenttData?.goalsData.showBlock == true ? {marginTop: '19rem'} : stageContenttData?.method == 'META_KW' || stageContenttData?.method == 'META_LA' ? {marginTop: '3rem'}: null">
      <div class="flex flex-col bg-blue-500 text-white rounded-xl space-y-2 p-4" style="height:auto;">
        <div class="text-sm pb-3">
          總預算
          <i
            class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
            v-tooltip.right="'以USD幣別為主'"
          ></i>
        </div>

        <div v-for="(item, index) in stageContentAllData" :key="index" class="border border-white rounded-md p-2">
          <div v-for="(sub_item, sub_index) in item" :key="sub_index" class="my-2">
            <span v-if="sub_item" class="text-md">{{ sub_item.method ? methodName(sub_item.method) : '' }}</span>
            <div class="float-right">
              <span v-if="sub_item" class="text-xl font-bold">{{ sub_item.budgetData.daily_budget ? sub_item.budgetData.daily_budget : '' }}</span>
              <span class="text-xs ml-1"> {{currencyListData.currency}}/day </span>
            </div>
          </div>
        </div>
        <hr>
        <div style="line-height:24px;">
          <span class="text-sm">總計（預計）</span>
          <div class="float-right">
            <span class="font-bold" style="font-size: 26px;">{{dailyBudgetTotal}}</span>
            <span class="text-sm ml-1"> {{currencyListData.currency}}/day </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 新手教學 -->
    <div v-if="(guideStep >= 19 && guideStep <= 34) || guideStep == 271" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
import { createApp, ref, watch } from 'vue'
import Dropdown from "primevue/dropdown";
import CascadeSelect from "primevue/cascadeselect";
import SelectButton from "primevue/selectbutton";
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import RuleForwardGroup from "./RuleForwardGroup.vue";
import RuleStopGroup from "./RuleStopGroup.vue";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "GoalsAndBudget",
  components: {
    Dropdown,
    CascadeSelect,
    SelectButton,
    InputSwitch,
    Loading,
    RuleForwardGroup,
    RuleStopGroup
  },
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: 1
    },
    // <!-- 新手教學 -->
    showGoalsAndBudget: {
      type: Boolean
    },
    editPage: {
      type: Boolean
    },
    getDate: {
      type: Number
    },
    budgetKWTotal: {
      type: Number
    },
    useEndDate: {
      type: Number
    },
    formMinAddition: {
      type: Number
    },
    dynBudgetData: {
      type: Object
    },
    viewDatalist: {
      type: Object
    },
    stageContent:{
      type: Object
    },
    stageContentAll:{
      type: Object
    },
    stageContentLength: {
      type: Number
    },
    stageIndex: {
      type: Number
    },
    stageItemIndex: {
      type: Number
    },
    stageTreeHaveTest: {
      type: Boolean
    },
    stageTreeList:{
      type: Object
    },
    dbRiskLevelCode: {
      type: String
    },
    currencyList: {
      type: Object
    },
    lang: {
      type: Object
    },
    useLang: {
      type: String
    },
    youtubeClose: {
      type: Boolean
    },
    haveASC: {
      type: String
    },
    efficientAi: {
      type: Boolean
    }
  },
  data() {
    return {
      showGoalsAndBudgetMyside: true,
      showObjectiveLoading: true,
      type: null,
      range: 20,
      transformCount: {id: "333", name: "消費金額"},
      transformDomain: null,
      isSetting: false,
      minAddition: 0,
      tmpObjective: '',
      productCatalogId: '',
      oldS: [
        {
          name: "購買-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "333",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        },
        {
          name: "開始結帳-未來實驗室的像素",
          code: "01",
          // sub: [
          //   {
          //     id: "01",
          //     name: "消費金額"
          //   },
          //   {
          //     id: "02",
          //     name: "轉換次數"
          //   }
          // ]
        },
        {
          name: "加入購物車-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "01",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        },
        {
          name: "完成註冊-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "01",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        },
        {
          name: "瀏覽內容-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "01",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        },
        {
          name: "潛在客戶-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "01",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        }
      ],
      domain: "",
      domainList: [],
      budgetUse: {},
      budgetUseList: [],
      risk_level_code: 'medium',
      x: 0,
      y: 0,
      h: 200,
      w: 320,
      active: false,
      src: "https://www.youtube.com/watch?v=6vD-2v5RWyk",
      vars: {
        rel: 0,
        start: 0,
        end: 0,
      },
      view_youtube: false,
      executingStatus: false,
      stopStatus: false,
      indexType: [
        { name: 'CPA', code: 'LIFETIME_CPA'},
        { name: 'ROAS', code: 'LIFETIME_ROAS'},
        { name: 'CTR', code: 'LIFETIME_CTR'},
        { name: '花費', code: 'LIFETIME_SPEND'},
        { name: '走期天數', code: 'DAY'},
        { name: '成果數', code: 'LIFETIME_ACTION'},
      ],
      indexTypeSub: [
        { name: '近7天', code: '7D'},
        { name: '整個走期', code: 'LIFETIME'},
        { name: '兩周', code: '2X'},
      ],
      compareType: [
        { name: '大於', code: 'GREATER_THAN'},
        { name: '大於等於', code: 'GREATER_THAN_EQUAL'},
        { name: '等於', code: 'EQUAL'},
        { name: '小於等於', code: 'LESS_THAN_EQUAL'},
        { name: '小於', code: 'LESS_THAN'},
      ],
      logicType: [
        { name: 'AND', code: 'AND'},
        { name: 'OR', code: 'OR'},
      ],
      timeType: [
        { name: '1天', code: '1d'},
        { name: '3天', code: '3d'},
        { name: '7天', code: '7d'},
      ],
      goItems: [
        { logicType: '', indexType: 'ROAS', compareType: 'equal', num: 50},
        { logicType: 'AND', indexType: 'SPEND', compareType: 'more', num: 10},
        { logicType: 'AND', indexType: 'CPA', compareType: 'less', num: 20},
      ],
      stopItems: [
        { logicType: '', indexType: 'ROAS', compareType: 'equal', num: 50},
        { logicType: 'AND', indexType: 'SPEND', compareType: 'more', num: 10},
        { logicType: 'AND', indexType: 'CPA', compareType: 'less', num: 20},
      ],
      dailyBudgetTotal: 0,
      isGoalsDataUpdating: false,
      isForwardDataUpdating: false,
      isStopDataUpdating: false,
      isBudgetExtraDataUpdating: false,
      isSubCampaignsContentUpdating: false,
      useASC: false,
      forwardNewData: null,
      stopNewData: null,
      budgetExtraNewData: null,
      testList: {
        "operator": "AND",
        "filters": [
          {
            "operator": "AND",
            "filters": [
                {
                "indexTypeSub": "7D", 
                    "indexType": "LIFETIME_CPA",
                    "operator": "GREATER_THAN_EQUAL",
                    "value": 231
                },
                {
                "operator": "OR",
                "filters": [
                  {
                    "indexTypeSub": "2X", 
                    "indexType": "LIFETIME_CTR",
                    "operator": "GREATER_THAN_EQUAL",
                    "value": 200
                  },
                  {
                    "indexTypeSub": "LIFETIME", 
                    "indexType": "LIFETIME_SPEND",
                    "operator": "GREATER_THAN_EQUAL",
                    "value": 306
                  }
                ]
              }
            ]
          },
          {
            "indexTypeSub": "2X", 
            "indexType": "LIFETIME_ROAS",
            "operator": "GREATER_THAN_EQUAL",
            "value": 231
          }
        ]
      },
      ruleFrequencyConditionCount: 0,
      ruleStopConditionCount: 0,
      canAddCondition: true,
      canStopAddCondition: true,
      ruleRaiseList: [{"operator":"AND","filters":[{"field":"7D_CPA","operator":"LESS_THAN","value":35}],"amount":35,"times":1,"count":0}, {"operator":"AND","filters":[{"field":"7D_CPA","operator":"LESS_THAN","value":44}],"amount":44,"times":2,"count":0}, {"operator":"AND","filters":[{"field":"7D_CPA","operator":"LESS_THAN","value":55}],"amount":55,"times":3,"count":0}, {"operator":"AND","filters":[{"field":"7D_CPA","operator":"LESS_THAN","value":66}],"amount":66,"times":4,"count":0}],
      field: [
        { name: 'CPA', code: '7D_CPA'},
        { name: 'ROAS', code: '7D_ROAS'},
      ]
    };
  },
  watch: {
    'youtubeClose':function(v){
      console.log('marketingmethod youtubeClose');
      console.log(v);

      let _tmpYoutubeType = v.split('_');

      console.log('_tmpYoutubeType');
      console.log(_tmpYoutubeType);

      console.log(typeof this.view_youtube);
      console.log(this.view_youtube);

      if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
        if(_tmpYoutubeType[0] == 'false' || (_tmpYoutubeType[1] != 'goal' && _tmpYoutubeType[1] != 'effect' && _tmpYoutubeType[1] != 'risk' && _tmpYoutubeType[1] != 'addition')){
          console.log('關閉#1');
          this.view_youtube = false
        } else {
          this.view_youtube = false
          setTimeout(() => {
            console.log("Delayed for 0.3 second.");
            this.teachVideo(_tmpYoutubeType[1]);
          }, "300")
        }
      }

      console.log('完畢');
      console.log(typeof this.view_youtube);
      console.log(this.view_youtube);
    },
    'haveASC':function(v){
      console.log('StageGoalsAndBudget haveASC');
      console.log(v);

      let _tmpUseASC = v.split('_');

      console.log('_tmpUseASC');
      console.log(_tmpUseASC);

      if(_tmpUseASC[0] != null && _tmpUseASC[0] != '' && typeof _tmpUseASC[0] != 'undefined'){
        console.log('#1');
        if(_tmpUseASC[0] == 'true'){
          console.log('#2');
          this.useASC = true;
        } else {
          console.log('#3');
          this.useASC = false;
        }
      }

      console.log(typeof this.useASC);
      console.log(this.useASC);
    },
    lang(value){
      this.budgetUse = { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_medium'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_medium'], code: "medium" };
      this.budgetUseList = [
        { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_high'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_high'], code: "high" },
        { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_medium'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_medium'], code: "medium" },
        { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_low'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_low'], code: "low" },
        { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_auto'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_auto'], code: "auto" }
      ];
    },
    transformCount (value){
      // console.log(this.transformCount);
      // console.log(value);
    },
    transformDomain (value){
      // console.log('transformDomain');
      // console.log(this.transformDomain);
      // console.log(value);
    },
    'stageContenttData.goalsData.campaign_objective'(value){
      console.log('stageContenttData.goalsData.campaign_objective');
      console.log(value);
      if(value != '' && value != null && typeof value != 'undefined'){
        this.tmpObjective = value;
      }
      this.$emit('childObjective', value);
    },
    'stageContenttData.goalsData.objective_option'(value){
      console.log('stageContenttData.goalsData.objective_option:'+value);

      this.$emit('childObjectiveOption', value);
    },
    'stageContenttData.goalsData.objective_list'(value){
      console.log('stageContenttData.goalsData.objective_list:');
      console.log(value);
    },
    'stageContenttData.goalsData.domain_list'(value){
      // console.log('stageContenttData.goalsData.domain_list:'+value);
    },
    // 'stageContenttData.goalsData.use_addition'(value){
    //   if(value == false){
    //     this.stageContenttData.goalsData.form_addition = 0;
    //   }
    // },
    'stageContenttData.goalsData.useAppEvent'(value){
      console.log(this.stageContenttData.goalsData.appItemsList);
      if(value === false){
        this.stageContenttData.goalsData.appItemsSelected = null;
      } else {
        if(this.stageContenttData.goalsData.appItemsSelected == '' || this.stageContenttData.goalsData.appItemsSelected == null || typeof this.stageContenttData.goalsData.appItemsSelected === "undefined"){
          this.stageContenttData.goalsData.appItemsSelected = this.stageContenttData.goalsData.appItemsList[0].code;
        }
      }
    },
    'stageContenttData.goalsData.use_addition'(value){
      console.log('stageContenttData.goalsData.use_addition');
      console.log(value);
      if(value == false){
        this.stageContenttData.goalsData.form_addition = 0;
      }
    },
    'formMinAddition'(value){
      // console.log('formMinAddition:'+this.formMinAddition);
      // console.log('this.stageContenttData.goalsData.form_addition:'+this.stageContenttData.goalsData.form_addition);
      this.minAddition = this.formMinAddition;

      if(this.stageContenttData.goalsData.form_addition < this.formMinAddition){
        this.stageContenttData.goalsData.form_addition = this.formMinAddition;
      }
    },
    'stageContenttData.goalsData.risk_level'(value){
      // console.log('stageContenttData.goalsData.risk_level:'+value.code);
      this.risk_level_code = value.code
    },
    'stageContenttData.forwardData.ditto_forward'(value){
      console.log('stageContenttData.forwardData.ditto_forward');
      console.log(value);
      console.log('b this.stageContentAllData');
      console.log(this.stageContentAllData);
      console.log(this.stageContenttData);
      console.log(this.stageIndex);

      if(this.stageIndex > 0){
        if(value == true){
          let _beforIndex = this.stageIndex - parseInt(1);
          let _beforeItemIndex = 0;

          console.log('b _beforeItemIndex', _beforeItemIndex);
          for(let i = 0; i < this.stageContentAllData[_beforIndex].length; i++){
            console.log('this.stageContentAllData['+_beforIndex+']['+i+']');
            if(this.stageContentAllData[_beforIndex][i].forwardData.showBlock === true){
              _beforeItemIndex = i;
            }
          }
          console.log('a _beforIndex', _beforIndex);
          console.log('a _beforeItemIndex', _beforeItemIndex);

          // this.stageContentAllData[this.stageIndex].forwardData = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex].forwardData));

          this.stageContentAllData[this.stageIndex][this.stageItemIndex].forwardData.rule_frequency = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].forwardData.rule_frequency));
          // this.stageContentAllData[this.stageIndex].forwardData.frequency = this.stageContentAllData[_beforIndex].forwardData.frequency;

          console.log('value');
          console.log(value);
          console.log(typeof value);
          // this.stageContentAllData[this.stageIndex].forwardData.ditto_forward = value;

          console.log('c1 this.stageContentAllData[this.stageIndex].forwardData');
          console.log(this.stageContentAllData[this.stageIndex][this.stageItemIndex].forwardData);

          // this.stageContentAllData[this.stageIndex].forwardData.ditto_forward = true;

          // console.log('c2 this.stageContentAllData[this.stageIndex].forwardData');
          // console.log(this.stageContentAllData[this.stageIndex].forwardData);

          if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
            let subLength =  this.stageContentAllData.length;
            console.log('this.stageIndex');
            console.log(this.stageIndex);
            for(let i = this.stageIndex; i < subLength; i++){
              console.log('this.stageContentAllData[i]');
              console.log(this.stageContentAllData[i]);
              let subItemLength =  this.stageContentAllData[i].length;
              for(let j = 0; j < subItemLength; j++){
                if(this.stageContentAllData[i][j].forwardData.ditto_forward == true){
                  console.log(i);
                  this.stageContentAllData[i][j].forwardData.rule_frequency = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].forwardData.rule_frequency));
                  // this.stageContentAllData[i].forwardData.frequency = this.stageContentAllData[this.stageIndex].forwardData.frequency;
                } else {
                  break;
                }
              }
            }
          }
        }
      }

      console.log('a this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    'stageContenttData.stopData.ditto_stop'(value){
      console.log('stageContenttData.stopData.ditto_stop');
      console.log(value);
      console.log('b this.stageContentAllData');
      console.log(this.stageContentAllData);
      console.log(this.stageContenttData);
      console.log(this.stageIndex);

      if(this.stageIndex > 0){
        if(value == true){
          let _beforIndex = this.stageIndex - parseInt(1);
          let _beforeItemIndex = 0;

          console.log('b _beforeItemIndex', _beforeItemIndex);
          for(let i = 0; i < this.stageContentAllData[_beforIndex].length; i++){
            console.log('this.stageContentAllData['+_beforIndex+']['+i+']');
            if(this.stageContentAllData[_beforIndex][i].forwardData.showBlock === true){
              _beforeItemIndex = i;
            }
          }
          console.log('a _beforIndex', _beforIndex);
          console.log('a _beforeItemIndex', _beforeItemIndex);

          // this.stageContentAllData[this.stageIndex].stopData = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex].stopData));

          // this.stageContentAllData[this.stageIndex].stopData.ditto_stop = value;

          this.stageContentAllData[this.stageIndex][this.stageItemIndex].stopData.rule_stop = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].stopData.rule_stop));

          if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
            let subLength =  this.stageContentAllData.length;
            for(let i = this.stageIndex; i < subLength; i++){
              let subItemLength =  this.stageContentAllData[i].length;
              for(let j = 0; j < subItemLength; j++){
                console.log('['+i+']['+j+']');
                console.log('this.stageContentAllData[i][j].stopData.ditto_stop', this.stageContentAllData[i][j].stopData.ditto_stop);
                console.log(typeof this.stageContentAllData[i][j].stopData.ditto_stop);
                if(this.stageContentAllData[i][j].stopData.ditto_stop == true){
                  console.log('this.stageContentAllData['+i+']['+j+'].stopData.ditto_stop == true');
                  if(this.stageContentAllData[this.stageIndex][this.stageItemIndex] != '' && this.stageContentAllData[this.stageIndex][this.stageItemIndex] != null && typeof this.stageContentAllData[this.stageIndex][this.stageItemIndex] !== 'undefined'){
                    this.stageContentAllData[i][j].stopData.rule_stop = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].stopData.rule_stop));
                  }
                } else {
                  break;
                }
              }
            }
          }
        }
      }

      console.log('stageContenttData.stopData.ditto_stop a this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    'stageContenttData.budgetExtraData.ditto_budget_extra'(value){
      console.log('stageContenttData.budgetExtraData.ditto_budget_extra');
      console.log(value);
      console.log('b this.stageContentAllData');
      console.log(this.stageContentAllData);
      console.log(this.stageContenttData);
      console.log(this.stageIndex);

      if(this.stageIndex > 0){
        if(value == true){
          let _beforIndex = this.stageIndex - parseInt(1);
          let _beforeItemIndex = 0;

          console.log('b _beforeItemIndex', _beforeItemIndex);
          for(let i = 0; i < this.stageContentAllData[_beforIndex].length; i++){
            console.log('this.stageContentAllData['+_beforIndex+']['+i+']');
            if(this.stageContentAllData[_beforIndex][i].forwardData.showBlock === true){
              _beforeItemIndex = i;
            }
          }
          console.log('a _beforIndex', _beforIndex);
          console.log('a _beforeItemIndex', _beforeItemIndex);

          // this.stageContentAllData[this.stageIndex].budgetExtraData = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex].budgetExtraData));

          // this.stageContentAllData[this.stageIndex].budgetExtraData.ditto_budget_extra = value;

          this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.amount = this.stageContentAllData[_beforIndex][_beforeItemIndex].budgetExtraData.amount;
          this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.frequency = this.stageContentAllData[_beforIndex][_beforeItemIndex].budgetExtraData.frequency;
          this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.budget_extra_list = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].budgetExtraData.budget_extra_list));

          if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
            let subLength =  this.stageContentAllData.length;
            for(let i = this.stageIndex; i < subLength; i++){
              let subItemLength =  this.stageContentAllData[i].length;
              for(let j = 0; j < subItemLength; j++){
                console.log('['+i+']['+j+']');
                console.log('this.stageContentAllData[i][j].budgetExtraData.ditto_budget_extra', this.stageContentAllData[i][j].budgetExtraData.ditto_budget_extra);
                console.log(typeof this.stageContentAllData[i][j].budgetExtraData.ditto_budget_extra);
                if(this.stageContentAllData[i][j].budgetExtraData.ditto_budget_extra == true){
                  console.log('套用');
                  this.stageContentAllData[i][j].budgetExtraData.amount = this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.amount;
                  this.stageContentAllData[i][j].budgetExtraData.frequency = this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.frequency;
                  this.stageContentAllData[i][j].budgetExtraData.budget_extra_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.budget_extra_list));
                } else {
                  break;
                }
              }
            }
          }
        }
      }

      console.log('stageContenttData.budgetExtraData.ditto_budget_extra a this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    'stageContenttData.goalsData': {
      handler(newValue, oldValue) {
        console.log('goalsData changed:', newValue);
        console.log('goalsData olddata:', oldValue);
        console.log(this.stageIndex);
        console.log(this.stageContentAllData);

        if(this.isGoalsDataUpdating == true){
          return;
        }

        this.isGoalsDataUpdating = true;

        this.goalsDataUdate();

        setTimeout(() => {
          this.isGoalsDataUpdating = false;
        }, 0);
      },
      deep: true // 深度监控
    },
    'stageContenttData.forwardData': {
      handler(newValue, oldValue) {
        console.log('forwardData changed:', newValue);
        console.log('forwardData olddata:', oldValue);

        console.log('b this.isForwardDataUpdating');
        console.log(this.isForwardDataUpdating);

        if(this.isForwardDataUpdating == true){
          return;
        }

        this.isForwardDataUpdating = true;

        this.forwardNewData = newValue;

        // await this.forwardDataUdate({ ...newValue });
        this.forwardDataUdate(newValue);

        console.log('c this.isForwardDataUpdating');
        console.log(this.isForwardDataUpdating);

        this.isForwardDataUpdating = false;

        console.log('a this.isForwardDataUpdating');
        console.log(this.isForwardDataUpdating);

        setTimeout(() => {
          this.isForwardDataUpdating = false;

          console.log('u this.isForwardDataUpdating');
          console.log(this.isForwardDataUpdating);
        }, 0);
      },
      deep: true // 深度监控
    },
    'stageContenttData.stopData': {
      handler(newValue, oldValue) {
        console.log('stopData changed:', newValue);
        console.log('stopData olddata:', oldValue);

        if(this.isStopDataUpdating == true){
          return;
        }

        this.isStopDataUpdating = true;

        this.stopNewData = newValue;

        this.stopDataUdate(newValue);

        this.isStopDataUpdating = false;

        setTimeout(() => {
          this.isStopDataUpdating = false;
        }, 0);
      },
      deep: true // 深度监控
    },
    'stageContenttData.budgetExtraData': {
      handler(newValue, oldValue) {
        console.log('budgetExtraData changed:', newValue);
        console.log('budgetExtraData olddata:', oldValue);
        console.log('this.isBudgetExtraDataUpdating', this.isBudgetExtraDataUpdating);

        if(this.isBudgetExtraDataUpdating == true){
          return;
        }

        this.isBudgetExtraDataUpdating = true;

        this.budgetExtraNewData = newValue;

        this.budgetExtraDataUdate(newValue);

        this.isBudgetExtraDataUpdating = false;

        setTimeout(() => {
          this.isBudgetExtraDataUpdating = false;

          console.log('update this.isBudgetExtraDataUpdating', this.isBudgetExtraDataUpdating);
        }, 0);
      },
      deep: true // 深度监控
    },
    // 'stageContentAllData': {
    //   handler(newVal, oldVal) {
    //     console.log('newVal');
    //     console.log(newVal);
    //     console.log('oldVal');
    //     console.log(oldVal);

    //     if(this.isSubCampaignsContentUpdating == true){
    //       return;
    //     }

    //     this.isSubCampaignsContentUpdating = true;

    //     this.subCampaignsContentUdate(newVal, oldVal);

    //     setTimeout(() => {
    //       this.isSubCampaignsContentUpdating = false;
    //     }, 0);
    //   },
    //   deep: true,
    //   immediate: true
    // },
    'stageContentAllData': {
      handler(newVal, oldVal) {
        console.log('stageContentAllData');
        console.log('newVal');
        console.log(newVal);
        console.log('oldVal');
        console.log(oldVal);

        if(this.isSubCampaignsContentUpdating == true){
          return;
        }

        this.isSubCampaignsContentUpdating = true;

        this.subCampaignsContentUdate(newVal, oldVal);

        setTimeout(() => {
          this.isSubCampaignsContentUpdating = false;
        }, 0);
      },
      deep: true,
      immediate: true
    },
    'stageContenttData.forwardData.rule_frequency': {
      handler(newValue) {
        console.log('stageContenttData.forwardData.rule_frequency');
        console.log(newValue);
        if (newValue) {
          this.updateConditionCount(); // 資料變化時更新計數
        }
      },
      deep: true, // 深度監聽
      immediate: true, // 初始化時立即觸發一次
    },
    'stageContenttData.stopData.rule_stop': {
      handler(newValue) {
        console.log('stageContenttData.stopData.rule_stop');
        console.log(newValue);
        if (newValue) {
          this.updateStopConditionCount(); // 資料變化時更新計數
        }
      },
      deep: true, // 深度監聽
      immediate: true, // 初始化時立即觸發一次
    },
  },
  methods: {
    handleFiltersUpdate(updatedFilters) {
      console.log('handleFiltersUpdate');
      console.log(updatedFilters);
      console.log(this.testList);
      this.testList = updatedFilters;
      console.log(this.testList);
    },
    changeDataFilters(updateData) {
      console.log('changeDataFilters updateData:', updateData);
      // this.testList = updateData; // 接收子元件傳遞來的資料並更新
      // console.log('testList:', this.testList);
      console.log('b forwardData.rule_frequency:', this.stageContenttData.forwardData.rule_frequency);
      this.stageContenttData.forwardData.rule_frequency = updateData;
      console.log('a forwardData.rule_frequency:', this.stageContenttData.forwardData.rule_frequency);
      this.ruleFrequencyConditionCount = this.countConditions(this.stageContenttData.forwardData.rule_frequency.filters);
      console.log('ruleFrequencyConditionCount:', this.ruleFrequencyConditionCount);

      this.updateConditionCount();
    },
    changeStopDataFilters(updateData) {
      console.log('changeStopDataFilters updateData:', updateData);
      // this.testList = updateData; // 接收子元件傳遞來的資料並更新
      // console.log('testList:', this.testList);
      console.log('b stopData.rule_stop:', this.stageContenttData.stopData.rule_stop);
      this.stageContenttData.stopData.rule_stop = updateData;
      console.log('a stopData.rule_stop:', this.stageContenttData.stopData.rule_stop);
      this.ruleStopConditionCount = this.countConditions(this.stageContenttData.stopData.rule_stop.filters);
      console.log('ruleStopConditionCount:', this.ruleStopConditionCount);

      this.updateStopConditionCount();
    },
    countConditions(filters) {
      console.log('countConditions');
      console.log(filters);
      let count = 0;

      const countRecursive = (filtersList) => {
        if (!filtersList || !Array.isArray(filtersList)) {
          // 如果 filtersList 为空或不是数组，则直接返回
          return;
        }

        filtersList.forEach((filter) => {
          if (filter.filters && Array.isArray(filter.filters)) {
            // 如果有子条件组，递归计算
            countRecursive(filter.filters);
          } else {
            // 否则是一条条件，增加数量
            count++;
          }
        });
      };

      countRecursive(filters);
      return count;
    },
    updateConditionCount() {
      console.log('updateConditionCount');
      this.ruleFrequencyConditionCount = this.countConditions(
        this.stageContenttData.forwardData.rule_frequency.filters
      );
      console.log('ruleFrequencyConditionCount:', this.ruleFrequencyConditionCount);
      // this.canAddCondition = this.ruleFrequencyConditionCount < 4;
    },
    updateStopConditionCount() {
      console.log('updateStopConditionCount');
      this.ruleStopConditionCount = this.countConditions(
        this.stageContenttData.stopData.rule_stop.filters
      );
      console.log('ruleStopConditionCount:', this.ruleStopConditionCount);
      // this.canStopAddCondition = this.ruleStopConditionCount < 4;
    },
    onReady() {
      console.log('youtube');
      this.$refs.youtube.playVideo()
      // this.$refs.youtube.pauseVideo()
    },
    onStateChange(e){
      console.log(e);

      if(e.data == 0){
        this.view_youtube = false
      }
    },
    teachVideo(v){
      this.$emit('checkClose')

      console.log('b teachVideo this.view_youtube');
      console.log(this.view_youtube);

      // this.view_youtube = false
      // let elem = document.getElementById('marketingDate');
      // let positio = this.getPosition(elem);
      // console.log('x:'+positio.x);
      // console.log('y:'+positio.y);

      console.log('a teachVideo this.view_youtube');
      console.log(this.view_youtube);

      // this.x = positio.x + parseInt(80);
      // this.y = positio.y

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      // console.log('windowWidth');
      // console.log(windowWidth);
      // console.log('windowHeight');
      // console.log(windowHeight);

      this.x = windowWidth - parseInt(390);
      this.y = windowHeight - parseInt(350);

      this.view_youtube = true;
      this.$emit('childYoutube', 'true_'+v)

      console.log('a this.view_youtube');
      console.log(this.view_youtube);

      console.log(v);

      switch(v){
        case 'goal':
          this.vars.start = 0
          this.vars.end = 42
          break;
        case 'effect':
          this.vars.start = 42
          this.vars.end = 91
          break;
        case 'risk':
          this.vars.start = 91
          this.vars.end = 179
          break;
        case 'addition':
          this.vars.start = 179
          this.vars.end = 227
          break;
      }

      this.playAgain = false
    },
    getPosition(element) {
      let x = 0;
      let y = 0;

      while ( element ) {
        x += element.offsetLeft - element.scrollLeft + element.clientLeft;
        y += element.offsetTop - element.scrollLeft + element.clientTop;
        element = element.offsetParent;
      }

      return { x: x, y: y };
    },
    print(val) {
      console.log(val)
    },
    doDragging(){
      console.log('doDragging');
    },
    setDomain() {
      if (this.domain) {
        var checkDomain = false;
        // console.log(this.stageContenttData.goalsData.domain_list);
        // console.log(this.domain);
        for (let i = 0; i < this.stageContenttData.goalsData.domain_list.length; i++) {
          if (this.stageContenttData.goalsData.domain_list[i].name === this.domain) {
            checkDomain = true
          }
        }

        if(checkDomain == false){
          let newOpt = { name: this.domain };
          this.stageContenttData.goalsData.domain_list.push(newOpt);
          this.transformDomain = newOpt;
          this.stageContenttData.goalsData.conversion_domain = newOpt;
        }
      }
    },
    objective_change (e) {
      // console.log(e.target.value);
      if(e.target.value != 'CONVERSIONS'){
        this.stageContenttData.goalsData.conversion_domain = null;
      }

      if(e.target.value == this.stageContenttData.goalsData.campaign_objective){
        // console.log('已選取');
      } else {
        this.stageContenttData.goalsData.campaign_objective = e.target.value;
        this.stageContenttData.goalsData.objective_option = null;

        this.showGoalsAndBudgetMyside = false;
        this.tmpObjective = e.target.value;

        if(e.target.value == 'PRODUCT_CATALOG_SALES'){
          console.log('目錄銷售');

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_assigned_catalogs.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.stageContenttData.goalsData.product_catalog_list = response.data.return_data.objective_list
                this.stageContenttData.goalsData.objective_list = [];
              }

              this.showGoalsAndBudgetMyside = true;
            });

        } else {
          this.stageContenttData.goalsData.product_catalog_id = '';
          this.stageContenttData.goalsData.product_catalog_list =  [];
          this.stageContenttData.goalsData.product_set_id = '';
          this.stageContenttData.goalsData.product_set_list = [];

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_action_event.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              campaign_id: this.$route.params.campaign_id,
              campaign_objective: e.target.value
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.stageContenttData.goalsData.objective_list = response.data.return_data.objective_list
              }

              this.showGoalsAndBudgetMyside = true;
            });

          if(e.target.value == 'CONVERSIONS'){
            axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_conversion_domains.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
              }))
              .then((response) => {
                if(response.data.status == 'success'){
                  this.stageContenttData.goalsData.domain_list = response.data.return_data
                }
              });
          }
        }
      }
    },
    product_catalog_change(e){
      console.log('product_catalog_change');
      console.log(e.value);
      console.log(this.stageContenttData.goalsData.product_catalog_id);
      let product_catalog_id = this.stageContenttData.goalsData.product_catalog_id;

      if(product_catalog_id != '' && product_catalog_id != null && typeof product_catalog_id != 'undefined'){
        this.showGoalsAndBudgetMyside = false;
        this.productCatalogId = product_catalog_id

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_catalog_product_sets.php', Qs.stringify({
            s_code: this.$route.params.id,
            catalog_id: product_catalog_id
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.stageContenttData.goalsData.product_set_list = response.data.return_data.objective_list
            }

            this.showGoalsAndBudgetMyside = true;
          });
      } else {
        Swal.fire(
                    this.lang['components']['Event']['GoalsAndBudget']['methods']['product_catalog_change']['swal_title'],
                    this.lang['components']['Event']['GoalsAndBudget']['methods']['product_catalog_change']['swal_text'],
                    "warning"
                  )
      }
    },
    product_set_change(e){
      console.log('product_catalog_change');
      console.log(e);
      // console.log(this.stageContenttData.goalsData.product_set_id);
      // let product_set_id = this.stageContenttData.goalsData.product_set_id;
      let product_catalog_id = this.stageContenttData.goalsData.product_catalog_id;
      if(product_catalog_id != '' && product_catalog_id != null && typeof product_catalog_id != 'undefined'){
        this.showGoalsAndBudgetMyside = false;

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_action_event.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            campaign_id: this.$route.params.campaign_id,
            campaign_objective: this.tmpObjective,
            catalog_id: product_catalog_id
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.stageContenttData.goalsData.objective_list = response.data.return_data.objective_list

              console.log(this.stageContenttData.goalsData.objective_list);
            }

            this.showGoalsAndBudgetMyside = true;
          });
      } else {
        Swal.fire(
                    this.lang['components']['Event']['GoalsAndBudget']['methods']['product_set_change']['swal_title'],
                    this.lang['components']['Event']['GoalsAndBudget']['methods']['product_set_change']['swal_text'],
                    "warning"
                  )
      }
    },
    objective_update (value) {
      console.log('objective_update', value);

      this.showObjectiveLoading = false;

      if(value == 'PRODUCT_CATALOG_SALES'){
        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_assigned_catalogs.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            update_type: true
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.stageContenttData.goalsData.product_catalog_list = response.data.return_data.objective_list
            }

            this.showObjectiveLoading = true;
          });

        if(this.stageContenttData.goalsData.product_catalog_id != '' && this.stageContenttData.goalsData.product_catalog_id != null && typeof this.stageContenttData.goalsData.product_catalog_id != 'undefined'){
          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_catalog_product_sets.php', Qs.stringify({
              s_code: this.$route.params.id,
              catalog_id: this.stageContenttData.goalsData.product_catalog_id,
              update_type: true
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.stageContenttData.goalsData.product_set_list = response.data.return_data.objective_list
              }
            });

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_action_event.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              campaign_id: this.$route.params.campaign_id,
              campaign_objective: value,
              catalog_id: this.stageContenttData.goalsData.product_catalog_id,
              update_type: true
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.stageContenttData.goalsData.objective_list = response.data.return_data.objective_list
              }
            });
        }
      } else {
        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_action_event.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            campaign_id: this.$route.params.campaign_id,
            campaign_objective: value,
            update_type: true
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.stageContenttData.goalsData.objective_list = response.data.return_data.objective_list
            }

            this.showObjectiveLoading = true;
          });

        if(value == 'CONVERSIONS'){
          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_conversion_domains.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              update_type: true
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.stageContenttData.goalsData.domain_list = response.data.return_data
              }
            });
        }
      }
    },
    budgetAddition(value){
      // console.log('value budgetAddition:'+value);

      // console.log('getDate budgetAddition:'+this.getDate);
      // console.log('budgetKWTotal budgetAddition:'+this.budgetKWTotal);
      // console.log('useEndDate budgetAddition:'+this.useEndDate);

      if(this.useEndDate == false){
        //有結束日期
        // console.log('有結束日期');
        //先算精準興趣總預算

        if(!isNaN(this.getDate) && this.getDate > 0){
          // console.log('有日期間距');
          var _tmp_days = this.getDate;
          var _tmp_total = this.budgetKWTotal;
          // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
          var _tmp_interval_week = 0;
          var interval_week = 0;
          var n = 0;
          var html = 0;
          var video_min_price = this.stageContenttData.goalsData.currency_video_min_price;
          var _tmp_budget_addition = video_min_price;

          let _test_total = 0;

          if(_tmp_days > 0){
              if(_tmp_days > 3){
                  n = Math.round(_tmp_days/7);
              }
          }

          //console.log(_tmp_total+'*7');
          var first_week = _tmp_total*7;

          for(var i = 1; i < n; i++){
              var days_pow = i + 1;
              // console.log('days_pow:'+days_pow);
              // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

              //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
              _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

              // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
              interval_week = interval_week + _tmp_interval_week;
          }

          // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

          //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
          var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

          if(_tmp_days > 0 && _tmp_total > 0){
              // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
              html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
          }

          _test_total = html;

          //計算最低預算比率
          let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

          this.minAddition = _ratio;

          if(parseInt(value) < parseInt(_ratio)){
            // console.log('有結束日期之下，不允許小於:'+_ratio);
            this.stageContenttData.goalsData.form_addition = _ratio;
          } else {
            // console.log(value +" > "+ _ratio);
          }
        } else {
          // console.log('沒結束日期也沒日期間距');
          var _tmp_keyword_split_budget = this.budgetKWTotal;
          var video_min_price = this.stageContenttData.goalsData.currency_video_min_price;
          var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
          if(_tmp_keyword_split_budget == 0){
              single_ratio = 0;
          }

          this.minAddition = single_ratio;

          if(parseInt(value) < parseInt(single_ratio)){
            // console.log('沒結束日期之下，不允許小於:'+single_ratio);
            this.stageContenttData.goalsData.form_addition = single_ratio;
          } else {
            // console.log(value +" > "+ single_ratio);
          }
        }

      } else {
        //沒結束日期
        // console.log('沒結束日期');
        var _tmp_keyword_split_budget = this.budgetKWTotal;
        var video_min_price = this.stageContenttData.goalsData.currency_video_min_price;
        var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        if(_tmp_keyword_split_budget == 0){
            single_ratio = 0;
        }

        this.minAddition = single_ratio;

        if(value < single_ratio){
          // console.log('沒結束日期之下，不允許小於:'+single_ratio);
          this.stageContenttData.goalsData.form_addition = single_ratio;
        } else {
          // console.log(value +" > "+ single_ratio);
        }
      }
    },
    num(value, offset, form, type, index){
      console.log('num');
      console.log(value +' | '+ offset)

      if(form == 'effect'){
        if(offset == 100){
          value = value.replace(/[^\d.]/g,"");
          value = value.replace(/^\./g,"");
          value = value.replace(/\.{2,}/g,".");
          value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
          value = value.replace(/^(\-)*(\d+)\.(\d{2}).*$/,'$1$2.$3');
        } else {
          value = value.replace(/[^\d]/g,'');
        }
      } else {
        if(type != 'DAY' && type != 'LIFETIME_ACTION'){
          value = value.replace(/[^\d.]/g,"");
          value = value.replace(/^\./g,"");
          value = value.replace(/\.{2,}/g,".");
          value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
          value = value.replace(/^(\-)*(\d+)\.(\d{2}).*$/,'$1$2.$3');
        } else {
          value = value.replace(/[^\d]/g,'');
        }
      }

      if(form == 'effect'){
        this.stageContenttData.budgetData.effect = value;

        console.log('this.stageContenttData.budgetData.effect');
        console.log(this.stageContenttData.budgetData.effect);
      }

      if(form == 'rule'){
        this.stageContenttData.forwardData.rule_frequency[index].num = value;

        console.log('this.stageContenttData.forwardData.rule_frequency[index].num');
        console.log(this.stageContenttData.forwardData.rule_frequency[index].num);
      }

      if(form == 'stop'){
        this.stageContenttData.stopData.rule_stop[index].num = value;

        console.log('this.stageContenttData.stopData.rule_stop[index].num');
        console.log(this.stageContenttData.stopData.rule_stop[index].num);
      }

      if(form == 'budget_extra_list'){
        // this.stageContenttData.budgetExtraData.budget_extra_list[index].num = value;
        this.stageContenttData.budgetExtraData.budget_extra_list[index].filters[0].value = value;

        // console.log('this.stageContenttData.budgetExtraData.budget_extra_list[index].num');
        // console.log(this.stageContenttData.budgetExtraData.budget_extra_list[index].num);
        console.log('this.stageContenttData.budgetExtraData.budget_extra_list[index].filters[0].value');
        console.log(this.stageContenttData.budgetExtraData.budget_extra_list[index].filters[0].value);
      }
    },
    validateInput(){
      let value = this.stageContenttData.budgetData.existing_customer_budget_percentage;

      // 限制范围在 0 到 100 之间
      if (value > 100) {
        value = 100;
      } else if (value < 0) {
        value = 0;
      }

      this.stageContenttData.budgetData.existing_customer_budget_percentage = value;
    },
    changeLogicType(value){
      console.log('changeLogicType');
      console.log(this.stageContenttData.forwardData.rule_frequency);
      for(let i = 0; i < this.stageContenttData.forwardData.rule_frequency.length; i++){
        if(i > 0){
          console.log('this.stageContenttData.forwardData.rule_frequency['+i+']');
          console.log(this.stageContenttData.forwardData.rule_frequency[i]);
          this.stageContenttData.forwardData.rule_frequency[i].logicType = value;
        }
      }
    },
    changeStopLogicType(value){
      console.log('changeStopLogicType');
      console.log(this.stageContenttData.stopData.rule_stop);
      for(let i = 0; i < this.stageContenttData.stopData.rule_stop.length; i++){
        if(i > 0){
          console.log('this.stageContenttData.stopData.rule_stop['+i+']');
          console.log(this.stageContenttData.stopData.rule_stop[i]);
          this.stageContenttData.stopData.rule_stop[i].logicType = value;
        }
      }
    },
    clearGoItems(index){
      this.stageContenttData.forwardData.rule_frequency.splice(index, 1);
    },
    clearStopItems(index){
      this.stageContenttData.stopData.rule_stop.splice(index, 1);
    },
    addGoItems(){
      console.log('addGoItems');
      console.log(this.stageContenttData.forwardData.rule_frequency);

      let _tmpGoItems = this.stageContenttData.forwardData.rule_frequency;

      if(_tmpGoItems.length < 4){
        let logicType = 'AND';
        if(this.stageContenttData.forwardData.rule_frequency[1] != '' && this.stageContenttData.forwardData.rule_frequency[1] != null && typeof this.stageContenttData.forwardData.rule_frequency[1] != 'undefined'){
          logicType = this.stageContenttData.forwardData.rule_frequency[1].logicType;
        }

        _tmpGoItems.push({ logicType: logicType, indexType: 'LIFETIME_CPA', indexTypeSub: '7D', subDisabled:false, compareType: 'LESS_THAN', num: ''});
      }
    },
    addStopItems(){
      console.log('addStopItems');
      console.log(this.stageContenttData.stopData.rule_stop);

      let _tmpStopItems = this.stageContenttData.stopData.rule_stop;

      if(_tmpStopItems.length < 4){
        let logicType = 'AND';
        if(this.stageContenttData.stopData.rule_stop[1] != '' && this.stageContenttData.stopData.rule_stop[1] != null && typeof this.stageContenttData.stopData.rule_stop[1] != 'undefined'){
          logicType = this.stageContenttData.stopData.rule_stop[1].logicType;
        }

        _tmpStopItems.push({ logicType: logicType, indexType: 'LIFETIME_CPA', indexTypeSub: '7D', subDisabled:false, compareType: 'LESS_THAN', num: ''});
      }
    },
    methodName(value){
      switch(value){
        case 'META_TEST':
          return '測試素材（Facebook）';
          break;
        case 'META_KW':
          return '精準興趣（Facebook）';
          break;
        case 'META_LA':
          return '類似受眾（Facebook）';
          break;
        case 'META_RT':
          return '再行銷（Facebook）';
          break;
        case 'META_ASC':
          return 'ASC（Facebook）';
          break;
        case 'TIKTOK_KW':
          return '精準興趣（Tiktok）';
          break;
        case 'TIKTOK_RT':
          return '再行銷（Tiktok）';
          break;
      }
    },
    budgetLimit(budget, method, limit){
      console.log('budgetLimit');
      console.log(budget);
      console.log(method);
      console.log(limit);

      let _methodName = this.methodName(method);

      let info = '<span style="  font-weight: 700;">'+_methodName+'</span>的預算, 至少要<span style="  font-weight: 700; color: red;">（'+this.currencyListData.currency+'）'+limit+'</span> 元。';
      if(method == 'META_TEST'){
        info = '<span style="  font-weight: 700;">'+_methodName+'</span>的預算，每設定要組素材，預算就要多<span style="  font-weight: 700; color: red;">（'+this.currencyListData.currency+'）'+limit+'</span> 元。';
      }

      if(budget < limit){
        console.log('預算小於下限');
        this.stageContenttData.budgetData.daily_budget = parseInt(limit);

        Swal.fire({
                  icon: 'warning',
                  title: '預算',
                  html: info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                });

      } else {
        console.log('預算正常');
        this.stageContenttData.budgetData.daily_budget = parseInt(budget);

        console.log(this.stageContentAllData);
      }
    },
    indexTypeChange(type, value, index){
      console.log('indexTypeChange');
      console.log(type +'|'+ value +'|'+ index);

      if(value == 'DAY'){
        if(type == 'rule'){
          this.stageContenttData.forwardData.rule_frequency[index].indexTypeSub = 'LIFETIME';
          this.stageContenttData.forwardData.rule_frequency[index].subDisabled = true;

          console.log(this.stageContenttData.forwardData.rule_frequency[index]);
        }

        if(type == 'stop'){
          this.stageContenttData.stopData.rule_stop[index].indexTypeSub = 'LIFETIME';
          this.stageContenttData.stopData.rule_stop[index].subDisabled = true;

          console.log(this.stageContenttData.stopData.rule_stop[index]);
        }
      } else {
        if(type == 'rule'){
          switch(value){
            case 'LIFETIME_CPA':
            case 'LIFETIME_CTR':
            case 'LIFETIME_ROAS':
              this.stageContenttData.forwardData.rule_frequency[index].indexTypeSub = '7D';
              break;
            case 'LIFETIME_ACTION':
            case 'LIFETIME_SPEND':
              this.stageContenttData.forwardData.rule_frequency[index].indexTypeSub = 'LIFETIME';
              break;
          }
          this.stageContenttData.forwardData.rule_frequency[index].subDisabled = false;

          console.log(this.stageContenttData.forwardData.rule_frequency[index]);
        }

        if(type == 'stop'){
          switch(value){
            case 'LIFETIME_CPA':
            case 'LIFETIME_CTR':
            case 'LIFETIME_ROAS':
              this.stageContenttData.stopData.rule_stop[index].indexTypeSub = '7D';
              break;
            case 'LIFETIME_ACTION':
            case 'LIFETIME_SPEND':
              this.stageContenttData.stopData.rule_stop[index].indexTypeSub = 'LIFETIME';
              break;
          }
          this.stageContenttData.stopData.rule_stop[index].subDisabled = false;

          console.log(this.stageContenttData.stopData.rule_stop[index]);
        }
      }
    },
    goalsDataUdate(){
      console.log('goalsDataUdate');

      // if(this.stageIndex > 0){
      //   let _beforeIndex = this.stageIndex - parseInt(1);

      //   console.log(this.stageContentAllData);
      //   console.log(this.stageContentAllData[_beforeIndex]);
      //   console.log(this.stageContentAllData[_beforeIndex].forwardData);
      //   let _newDataFrequency = newValue.frequency;
      //   let _newDataRuleFrequency = JSON.stringify(newValue.rule_frequency);
      //   let _oldDataFrequency = this.stageContentAllData[_beforeIndex].forwardData.frequency;
      //   let _oldDataRuleFrequency = JSON.stringify(this.stageContentAllData[_beforeIndex].forwardData.rule_frequency);

      //   if((_newDataFrequency == _oldDataFrequency) && (_newDataRuleFrequency === _oldDataRuleFrequency) && newValue.ditto_forward == true){
      //     console.log('#一樣');
      //     console.log(_newDataFrequency);
      //     console.log(_oldDataFrequency);
      //     console.log(_newDataRuleFrequency);
      //     console.log(_oldDataRuleFrequency);

      //     this.stageContentAllData[this.stageIndex].forwardData.ditto_forward = true;
      //   } else {
      //     console.log('#不一樣');
      //     console.log(_newDataFrequency);
      //     console.log(_oldDataFrequency);
      //     console.log(_newDataRuleFrequency);
      //     console.log(_oldDataRuleFrequency);
      //     this.stageContentAllData[this.stageIndex].forwardData.ditto_forward = false;
      //   }
      // } else {
      console.log('this.stageTreeHaveTest', this.stageTreeHaveTest);
      console.log('this.stageIndex', this.stageIndex);
      console.log('this.stageItemIndex', this.stageItemIndex);
      if(this.stageTreeHaveTest == true && this.stageIndex == 0 && this.stageItemIndex == 0){
        console.log('有測試素材');
        if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
          let subLength =  this.stageContentAllData.length;
          console.log('0');
          console.log(this.stageIndex);
          for(let i = 1; i < subLength; i++){
            // console.log('this.stageContentAllData['+i+'].goalsData');
            // console.log(this.stageContentAllData[i].goalsData);
            let subItemLength =  this.stageContentAllData[i].length;
            for(let j = 0; j < subItemLength; j++){
              console.log(this.stageContentAllData[i][j].method);
              if(this.stageContentAllData[i][j].method != 'TIKTOK_KW' && this.stageContentAllData[i][j].method != 'TIKTOK_RT'){
                console.log('開始更新');
                if(this.stageContentAllData[i][j].goalsData != null && this.stageContentAllData[i][j].goalsData != '' && typeof this.stageContentAllData[i][j].goalsData != 'undefined'){
                  this.stageContentAllData[i][j].goalsData.campaign_objective = this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.campaign_objective;
                  this.stageContentAllData[i][j].goalsData.objective_option = this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.objective_option;
                  this.stageContentAllData[i][j].goalsData.objective_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.objective_list));
                  this.stageContentAllData[i][j].goalsData.product_catalog_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.product_catalog_list));
                  this.stageContentAllData[i][j].goalsData.product_set_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.product_set_list));
                  this.stageContentAllData[i][j].goalsData.optimization_action = this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.optimization_action;
                  this.stageContentAllData[i][j].goalsData.optimization_goal = this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.optimization_goal;
                  this.stageContentAllData[i][j].goalsData.product_catalog_id = this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.product_catalog_id;
                  this.stageContentAllData[i][j].goalsData.product_set_id = this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.product_set_id;
                  this.stageContentAllData[i][j].goalsData.pixel_id = this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.pixel_id;
                  this.stageContentAllData[i][j].goalsData.pixel_event = this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.pixel_event;
                  this.stageContentAllData[i][j].goalsData.conversion_domain = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.conversion_domain));
                  this.stageContentAllData[i][j].goalsData.domain_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].goalsData.domain_list));
                }
              }
            }
          }
        }
      }

      // }

      console.log('goalsDataUdate b this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    forwardDataUdate(formNewValue){
      console.log(this.stageIndex);

      console.log('b forwardDataUdate');
      console.log(this.formNewValue);
      console.log(this.forwardNewData);

      // await new Promise(resolve => setTimeout(resolve, 1000));

      console.log('a forwardDataUdate');
      console.log(this.formNewValue);
      console.log(this.forwardNewData);

      console.log('Updating goals data with:', formNewValue);
      let newValue = formNewValue;

      console.log('b newValue');
      console.log(newValue);
      console.log(this.forwardNewData);

      if(newValue === undefined){
        console.log('#1');
        newValue = this.forwardNewData;
      }

      if(typeof newValue === 'undefined'){
        console.log('#2');
        newValue = this.forwardNewData;
      }

      console.log('a newValue');
      console.log(newValue);
      console.log(newValue);
      console.log(this.forwardNewData);

      this.isForwardDataUpdating = false;

      console.log('u forwardDataUdate this.isForwardDataUpdating');
      console.log(this.isForwardDataUpdating);
      console.log(this.forwardNewData);

      if(this.stageIndex > 0){
        let _beforeIndex = this.stageIndex - parseInt(1);
        let _beforeItemIndex = 0;

        console.log('b _beforeItemIndex', _beforeItemIndex);
        for(let i = 0; i < this.stageContentAllData[_beforeIndex].length; i++){
          console.log('this.stageContentAllData['+_beforeIndex+']['+i+']');
          if(this.stageContentAllData[_beforeIndex][i].forwardData.showBlock === true){
            _beforeItemIndex = i;
          }
        }
        console.log('a _beforeIndex', _beforeIndex);
        console.log('a _beforeItemIndex', _beforeItemIndex);

        console.log(this.stageContentAllData);
        console.log(this.stageContentAllData[_beforeIndex][_beforeItemIndex]);
        console.log(this.stageContentAllData[_beforeIndex][_beforeItemIndex].forwardData);
        // let _newDataFrequency = newValue.frequency;
        let _newDataRuleFrequency = JSON.stringify(newValue.rule_frequency);
        // let _oldDataFrequency = this.stageContentAllData[_beforeIndex][_beforeItemIndex].forwardData.frequency;
        let _oldDataRuleFrequency = JSON.stringify(this.stageContentAllData[_beforeIndex][_beforeItemIndex].forwardData.rule_frequency);

        // if((_newDataFrequency == _oldDataFrequency) && (_newDataRuleFrequency === _oldDataRuleFrequency) && newValue.ditto_forward == true){
        if((_newDataRuleFrequency === _oldDataRuleFrequency) && newValue.ditto_forward == true){
          console.log('#一樣');
          // console.log(_newDataFrequency);
          // console.log(_oldDataFrequency);
          console.log(_newDataRuleFrequency);
          console.log(_oldDataRuleFrequency);

          this.stageContentAllData[this.stageIndex][this.stageItemIndex].forwardData.ditto_forward = true;
        } else {
          console.log('#不一樣');
          // console.log(_newDataFrequency);
          // console.log(_oldDataFrequency);
          console.log(_newDataRuleFrequency);
          console.log(_oldDataRuleFrequency);
          this.stageContentAllData[this.stageIndex][this.stageItemIndex].forwardData.ditto_forward = false;
        }
      } else {
        if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
          let subLength =  this.stageContentAllData.length;
          console.log('0');
          console.log(this.stageIndex);
          for(let i = 1; i < subLength; i++){
            console.log('this.stageContentAllData['+i+']');
            console.log(this.stageContentAllData[i]);
            let subItemLength =  this.stageContentAllData[i].length;
            for(let j = this.stageItemIndex; j < subItemLength; j++){
              if(this.stageContentAllData[i][j].forwardData.ditto_forward == true){
                this.stageContentAllData[i][j].forwardData.rule_frequency = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].forwardData.rule_frequency));
                // this.stageContentAllData[i].forwardData.frequency = this.stageContentAllData[this.stageIndex].forwardData.frequency;
              } else {
                break;
              }
            }
          }
        }
      }

      console.log('forwardDataUdate b this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    stopDataUdate(newValue){
      console.log('stopDataUdate');
      console.log('this.stageIndex',this.stageIndex);

      if(newValue === undefined){
        console.log('#1');
        newValue = this.stopNewData;
      }

      if(typeof newValue === 'undefined'){
        console.log('#2');
        newValue = this.stopNewData;
      }

      this.isStopDataUpdating = false;

      if(this.stageIndex > 0){
        let _beforeIndex = this.stageIndex - parseInt(1);
        let _beforeItemIndex = 0;

        console.log('b _beforeItemIndex', _beforeItemIndex);
        for(let i = 0; i < this.stageContentAllData[_beforeIndex].length; i++){
          console.log('this.stageContentAllData['+_beforeIndex+']['+i+']');
          if(this.stageContentAllData[_beforeIndex][i].forwardData.showBlock === true){
            _beforeItemIndex = i;
          }
        }
        console.log('a _beforeIndex', _beforeIndex);
        console.log('a _beforeItemIndex', _beforeItemIndex);

        console.log(this.stageContentAllData);
        console.log(this.stageContentAllData[_beforeIndex][_beforeItemIndex]);
        console.log(this.stageContentAllData[_beforeIndex][_beforeItemIndex].stopData);
        let _newDataRuleFrequency = JSON.stringify(newValue.rule_stop);
        let _oldDataRuleFrequency = JSON.stringify(this.stageContentAllData[_beforeIndex][_beforeItemIndex].stopData.rule_stop);

        if(_newDataRuleFrequency === _oldDataRuleFrequency && newValue.ditto_stop == true){
          console.log('#一樣');
          console.log(_newDataRuleFrequency);
          console.log(_oldDataRuleFrequency);

          this.stageContentAllData[this.stageIndex][this.stageItemIndex].stopData.ditto_stop = true;
        } else {
          console.log('#不一樣');
          console.log(_newDataRuleFrequency);
          console.log(_oldDataRuleFrequency);
          this.stageContentAllData[this.stageIndex][this.stageItemIndex].stopData.ditto_stop = false;
        }
      } else {
        console.log('向下繼承設定');
        if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
          let subLength =  this.stageContentAllData.length;
          console.log('0');
          console.log(this.stageIndex);
          for(let i = 1; i < subLength; i++){
            let subItemLength =  this.stageContentAllData[i].length;
            for(let j = this.stageItemIndex; j < subItemLength; j++){
              console.log('this.stageContentAllData['+i+']['+j+'].stopData');
              console.log(this.stageContentAllData[i][j].stopData);
              if(this.stageContentAllData[i][j].stopData.ditto_stop === true){
                console.log('有設套用');
                console.log('this.stageContentAllData['+i+']['+j+'].stopData.ditto_stop === true');
                if(this.stageContentAllData[this.stageIndex][this.stageItemIndex] != '' && this.stageContentAllData[this.stageIndex][this.stageItemIndex] != null && typeof this.stageContentAllData[this.stageIndex][this.stageItemIndex] !== 'undefined'){
                  this.stageContentAllData[i][j].stopData.rule_stop = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].stopData.rule_stop));
                }
              } else {
                console.log('沒套用 跳出');
                break;
              }
            } 
          }
        }
      }

      console.log('stopDataUdate b this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    budgetExtraDataUdate(newValue){
      console.log('budgetExtraDataUdate');
      console.log(this.stageIndex);

      if(newValue === undefined){
        console.log('#1');
        newValue = this.budgetExtraNewData;
      }

      if(typeof newValue === 'undefined'){
        console.log('#2');
        newValue = this.budgetExtraNewData;
      }

      this.isForwardDataUpdating = false;

      if(this.stageIndex > 0){
        let _beforeIndex = this.stageIndex - parseInt(1);
        let _beforeItemIndex = 0;

        console.log('b _beforeItemIndex', _beforeItemIndex);
        for(let i = 0; i < this.stageContentAllData[_beforeIndex].length; i++){
          console.log('this.stageContentAllData['+_beforeIndex+']['+i+']');
          if(this.stageContentAllData[_beforeIndex][i].forwardData.showBlock === true){
            _beforeItemIndex = i;
          }
        }
        console.log('a _beforeIndex', _beforeIndex);
        console.log('a _beforeItemIndex', _beforeItemIndex);

        console.log(this.stageContentAllData);
        console.log(this.stageContentAllData[_beforeIndex][_beforeItemIndex]);
        console.log(this.stageContentAllData[_beforeIndex][_beforeItemIndex].budgetExtraData);
        let _newDataAmount = newValue.amount;
        let _oldDataAmount = this.stageContentAllData[_beforeIndex][_beforeItemIndex].budgetExtraData.amount;
        let _newDataFrequency = newValue.frequency;
        let _oldDataFrequency = this.stageContentAllData[_beforeIndex][_beforeItemIndex].budgetExtraData.frequency;
        let _newDataBudgetExtraList = JSON.stringify(newValue.budget_extra_list);
        let _oldDataBudgetExtraList = JSON.stringify(this.stageContentAllData[_beforeIndex][_beforeItemIndex].budgetExtraData.budget_extra_list);

        if((_newDataAmount === _oldDataAmount) && (_newDataFrequency === _oldDataFrequency) && (_newDataBudgetExtraList === _oldDataBudgetExtraList) && newValue.ditto_budget_extra == true){
          console.log('#一樣');
          console.log(_newDataAmount);
          console.log(_oldDataAmount);
          console.log(_newDataFrequency);
          console.log(_oldDataFrequency);
          console.log(_newDataBudgetExtraList);
          console.log(_oldDataBudgetExtraList);

          this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.ditto_budget_extra = true;
        } else {
          console.log('#不一樣');
          console.log(_newDataAmount);
          console.log(_oldDataAmount);
          console.log(_newDataFrequency);
          console.log(_oldDataFrequency);
          console.log(_newDataBudgetExtraList);
          console.log(_oldDataBudgetExtraList);
          this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.ditto_budget_extra = false;
        }
      } else {
        if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
          let subLength = this.stageContentAllData.length;
          console.log('0');
          console.log(this.stageIndex);
          for(let i = 1; i < subLength; i++){
            console.log('this.stageContentAllData['+i+']');
            console.log(this.stageContentAllData[i]);
            let subItemLength =  this.stageContentAllData[i].length;
            for(let j = 0; j < subItemLength; j++){
              if(this.stageContentAllData[i][j].budgetExtraData){
                if(this.stageContentAllData[i][j].budgetExtraData.ditto_budget_extra == true){
                  this.stageContentAllData[i][j].budgetExtraData.amount = this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.amount;
                  this.stageContentAllData[i][j].budgetExtraData.frequency = this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.frequency;
                  this.stageContentAllData[i][j].budgetExtraData.budget_extra_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].budgetExtraData.budget_extra_list));
                } else {
                  break;
                }
              }
            }
          }
        }
      }

      console.log('stopDataUdate b this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    // subCampaignsContentUdate(newVal, oldVal){
    //   if (!Array.isArray(oldVal)) {
    //     oldVal = [];
    //   }
    //   const _self = this;
    //   this.dailyBudgetTotal = 0;
    //   if(newVal != null && newVal != '' && typeof newVal !== 'undefined'){
    //     newVal.forEach((newItem, index) => {
    //       const oldItem = oldVal[index];
    //       if (oldItem && newItem.budgetData.daily_budget !== oldItem.budgetData.daily_budget) {
    //         console.log(`Item ${newItem.method} total changed from ${oldItem.budgetData.daily_budget} to ${newItem.budgetData.daily_budget}`);
    //         // 在这里处理参数变化后的逻辑
    //       } else if (!oldItem) {
    //         console.log(`Item ${newItem.method} total is now: ${newItem.budgetData.daily_budget}`);
    //       }

    //       console.log('newItem.budgetData.daily_budget');
    //       console.log(newItem.budgetData.daily_budget);

    //       let _tmpDailyBudget = newItem.budgetData.daily_budget;
    //       if(_tmpDailyBudget == null || _tmpDailyBudget == '' || typeof(_tmpDailyBudget) == 'undefined'){
    //         _tmpDailyBudget = 0;
    //       }

    //       _self.dailyBudgetTotal += parseInt(newItem.budgetData.daily_budget);

    //       console.log('_self.dailyBudgetTotal');
    //       console.log(_self.dailyBudgetTotal);
    //     });
    //   }
    // },
    subCampaignsContentUdate(newVal, oldVal){
      console.log('subCampaignsContentUdate', newVal, oldVal);
      if (!Array.isArray(oldVal)) {
        oldVal = [];
      }
      const _self = this;
      this.dailyBudgetTotal = 0;
      if(newVal != null && newVal != '' && typeof newVal !== 'undefined'){
        let total = 0;

        // 遍歷 stageTreeContent 並加總 budgetData.daily_budget
        newVal.forEach(group => {
          group.forEach(item => {
            let _daily_budget = parseInt(item.budgetData.daily_budget);
            if (item.budgetData && typeof item.budgetData.daily_budget === "number") {
              total += parseInt(item.budgetData.daily_budget);
            }
          });
        });

        this.dailyBudgetTotal = total;
      }
    },
    timesCheck(index) {
      console.log('timesCheck');
      let numericValue = this.stageContenttData.budgetExtraData.budget_extra_list[index].times.replace(/\D/g, '');
      console.log(numericValue);
      if (numericValue > 10) {
        numericValue = '10';
      }
      this.stageContenttData.budgetExtraData.budget_extra_list[index].times = numericValue;
    },
    removeRuleRaiseList(index){
      console.log('removeRuleRaiseList', index);
      this.stageContenttData.budgetExtraData.budget_extra_list.splice(index, 1);
    },
    addRuleRaiseItems(){
      this.stageContenttData.budgetExtraData.budget_extra_list.push({"operator":"AND","filters":[{"field":"7D_CPA","operator":"EQUAL","value":0}],"amount":0,"times":0,"count":0});
    }
  },
  computed: {
    campaignObjective: {
      get() {
        if (this.stageContenttData && this.stageContenttData.goalsData) {
          return this.stageContenttData.goalsData.campaign_objective || 'CONVERSIONS';
        }
        return false;
      },
      set(value) {
        if (!this.stageContenttData.goalsData) {
          this.$set(this.stageContenttData, "goalsData", {}); // 初始化 goalsData
        }
        this.stageContenttData.goalsData.campaign_objective = value;
      },
    },
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    stageContenttData:{
      get: function () {
        return this.stageContent
      },
      set: function (value) {
        this.$emit('update:stageContenttData', value)
      },
    },
    stageContentAllData:{
      get: function () {
        return this.stageContentAll
      },
      set: function (value) {
        this.$emit('update:stageContentAllData', value)
      },
    },
    currencyListData: {
      get: function () {
        return this.currencyList
      },
      set: function (value) {
        this.$emit('update:currencyListData', value)
      },
    },
  }
};
</script>

<style lang="scss" scope>
.p-tooltip {
  max-width: 23rem !important;
}
</style>
